import hookFetch from './hookFetch';
import hookXHR from './hookXHR';
import hookMtop from './hookMtop';
export default {
  hookFetch: hookFetch,
  hookXHR: hookXHR,
  hookMtop: hookMtop
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/libs/index.js
// module id = null
// module chunks = 